// extracted by mini-css-extract-plugin
module.exports = {"TabList":"ProductsListWithTabs_TabList__2ehLx","Tab":"ProductsListWithTabs_Tab__296Lb","TabActive":"ProductsListWithTabs_TabActive__3aJVo"};